<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:right_view>
      <TsMenuButton ref='tsMenuButton' @methodEnum='methodEnum' ></TsMenuButton>
      <div class="h100-140 h-scroll" style="padding-top: 30px;">
        <DigitalCountByTypeChart ref='registerCountByTypeChart'></DigitalCountByTypeChart>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from '../../layouts/BasicLayout';
import TsMenuButton from '../../components/tsConfig/TsMenuButton';
import DigitalCountByTypeChart from '../../components/tsConfig/DigitalCountByTypeStatistics/DigitalCountByTypeChart';

export default {
  name: 'DigitalCountByTypeStatisticsPage',
  components: {
    BasicLayout,
    TsMenuButton,
    DigitalCountByTypeChart
  },
  data() {
    return {
      left: {
        show: false,
        name: ''
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('TS.trafficMeasurement')}/${this.$t('TS.digitalServiceStatistics')}/${this.$t('TS.msgCountStatistics')}`
      }
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'search':
          this.$refs.registerCountByTypeChart.searchPage();
          break;
        default:
      }
    }
  }
};
</script>

<style scoped>

</style>
